module.exports = __webpack_public_path__ + "media/images/common/ico-ramen-3811dec8301e6041d1292d27cb9df38d.svg";